import React from "react"
import { DefaultText, SemiBoldLabelText } from "@/UI"
import { DateTime } from "luxon"
import { OrderStatusesTypes } from "@/types/statuses.types"
import { useTranslation } from "react-i18next"

interface ProgressBarStatusTextProps {
  status: OrderStatusesTypes
  eta?: number
  stepCompleted: boolean
  center?: boolean
  style?: { marginLeft: string }
  isCancelled: boolean
}

const ProgressBarStatusText: React.FC<ProgressBarStatusTextProps> = ({
  status,
  stepCompleted,
  eta,
  center = true,
  style,
  isCancelled,
}) => {
  const { t } = useTranslation()
  const translationKey = `common.order-status.${status}`
  const etaDate = eta && eta > 0 ? DateTime.fromMillis(eta) : undefined
  const etaEstimate = etaDate && etaDate.toFormat("HH:mm")

  const color =
    !isCancelled || status === OrderStatusesTypes.CREATED || status === OrderStatusesTypes.CANCELLED
      ? "#111827"
      : "#9CA3AF"

  return (
    <div
      className={`flex flex-col ${center ? "items-center" : ""} leading-tight h-full`}
      style={style}
    >
      <SemiBoldLabelText className="flex flex-grow">
        <span style={{ color }}>{t(translationKey)}</span>
      </SemiBoldLabelText>
      {(!isCancelled || status === OrderStatusesTypes.CREATED) && (
        <>
          <DefaultText>{etaDate && etaDate.toFormat("EEE yyyy-MM-dd")}</DefaultText>
          <DefaultText>
            {!stepCompleted && !!etaEstimate && !isCancelled && "ETA "}
            {!!etaEstimate && etaEstimate}
          </DefaultText>
        </>
      )}
    </div>
  )
}

export default ProgressBarStatusText
